module.exports = __webpack_public_path__ + "static/media/scan_container.59bea0fe.png";